export const META_PIXEL_ID = '898255663340503'

type Fbq = {
  (...args: unknown[]): void
  callMethod?: (...args: unknown[]) => void
  queue: unknown[]
  push: Fbq
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  if (!window.fbq) {
    const fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod(...args)
      } else {
        fbq.queue.push(args)
      }
    } as Fbq
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')
  window.fbq?.('track', 'ViewContent', {
    content_name: 'The Running Professional Pack',
    value: 27,
    currency: 'USD',
  })
}

export function trackInitiateCheckout() {
  window.fbq?.('track', 'InitiateCheckout', {
    content_name: 'The Running Professional Pack',
    value: 27,
    currency: 'USD',
  })
}
